import {Material, MeshBasicMaterial, MeshPhongMaterial, MeshPhysicalMaterial, Object3D} from "three";

/**
 * Dispose content of object
 * doesn't dispose the object itself
 * @param object
 */
export function disposeContent<T extends Object3D<any>>(object: T){
    (object as any)?.geometry?.dispose?.()
    disposeMaterial((object as any)?.material)
}


/**
 * Generic material dispose function
 * @param material
 */
export function disposeMaterial<T extends Material>(material: T): void {
    if(!material){ return; }

    if (material instanceof MeshPhysicalMaterial || material instanceof MeshPhongMaterial || material instanceof MeshBasicMaterial) {
        material?.map?.dispose?.()
    }

    Array.isArray(material)
        ? material.forEach( (m: any)=> m?.dispose?.())
        : material?.dispose?.();
}